module.exports = __webpack_public_path__ + "img/orangesky.c79a379.png";